import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import { ChevronLeft, Check } from "lucide-react";
import type { ThemeClasses } from "./NewsletterModal";
type CategoryOption = {
  id: string;
  name: string;
};
interface InterestsStepProps {
  categories: CategoryOption[];
  categoriesLoading: boolean;
  categoriesErrorMessage: string;
  selectedInterests: string[];
  otpSendError: string;
  isSendingOtp: boolean;
  onBack: () => void;
  onToggleInterest: (id: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
  theme: ThemeClasses;
}
export function InterestsStep(t0) {
  const $ = _c(59);
  const {
    categories,
    categoriesLoading,
    categoriesErrorMessage,
    selectedInterests,
    otpSendError,
    isSendingOtp,
    onBack,
    onToggleInterest,
    onSubmit,
    onCancel,
    theme
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      x: 20
    };
    t2 = {
      opacity: 1,
      x: 0
    };
    t3 = {
      opacity: 0,
      x: -20
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== categories || $[4] !== onToggleInterest || $[5] !== selectedInterests || $[6] !== theme.bg || $[7] !== theme.border || $[8] !== theme.font || $[9] !== theme.gradient || $[10] !== theme.text) {
    let t5;
    if ($[12] !== onToggleInterest || $[13] !== selectedInterests || $[14] !== theme.bg || $[15] !== theme.border || $[16] !== theme.font || $[17] !== theme.gradient || $[18] !== theme.text) {
      t5 = category => {
        const isSelected = selectedInterests.includes(category.id);
        return <button key={category.id} type="button" onClick={() => onToggleInterest(category.id)} className={`p-3 sm:p-4 rounded-xl transition-all text-left relative group border-2 ${isSelected ? `bg-white ${theme.border} shadow-md` : "bg-white border-gray-200 hover:border-gray-300 hover:shadow-sm"}`}>{isSelected && <div className={`absolute inset-0 bg-gradient-to-br ${theme.gradient} to-transparent pointer-events-none rounded-xl`} />}<div className="flex items-center justify-between gap-2 sm:gap-3 relative z-10"><span className={`text-xs sm:text-sm font-medium flex-1 ${theme.font} ${isSelected ? theme.text : "text-gray-900"}`}>{category.name}</span>{isSelected && <div className={`w-4 h-4 sm:w-5 sm:h-5 ${theme.bg} rounded-full flex items-center justify-center flex-shrink-0 transition-transform scale-110`}><Check className="w-2.5 h-2.5 sm:w-3.5 sm:h-3.5 text-white stroke-[3.5]" /></div>}</div></button>;
      };
      $[12] = onToggleInterest;
      $[13] = selectedInterests;
      $[14] = theme.bg;
      $[15] = theme.border;
      $[16] = theme.font;
      $[17] = theme.gradient;
      $[18] = theme.text;
      $[19] = t5;
    } else {
      t5 = $[19];
    }
    t4 = categories.map(t5);
    $[3] = categories;
    $[4] = onToggleInterest;
    $[5] = selectedInterests;
    $[6] = theme.bg;
    $[7] = theme.border;
    $[8] = theme.font;
    $[9] = theme.gradient;
    $[10] = theme.text;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[20] !== t4) {
    t5 = <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3 mb-4 sm:mb-6 max-h-60 sm:max-h-96 overflow-y-auto pr-2">{t4}</div>;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  const t6 = `text-gray-500 mb-2 sm:mb-3 text-center text-[10px] sm:text-sm ${theme.font}`;
  let t7;
  if ($[22] !== t6) {
    t7 = <p className={t6}>Select topics to personalize your experience</p>;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== categoriesErrorMessage || $[25] !== theme.font) {
    t8 = categoriesErrorMessage && <p className={`text-center text-[10px] sm:text-xs text-red-500 ${theme.font} mb-2`}>{categoriesErrorMessage}</p>;
    $[24] = categoriesErrorMessage;
    $[25] = theme.font;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  const t9 = `text-xs sm:text-sm text-gray-600 hover:text-gray-900 font-medium flex items-center gap-1 sm:gap-2 transition-colors ${theme.font}`;
  let t10;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ChevronLeft className="w-3.5 h-3.5 sm:w-4 sm:h-4" />;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== onBack || $[29] !== t9) {
    t11 = <button type="button" onClick={onBack} className={t9}>{t10}Back</button>;
    $[28] = onBack;
    $[29] = t9;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  const t12 = `text-xs sm:text-sm text-gray-600 font-medium ${theme.font}`;
  const t13 = selectedInterests.length === 1 ? "category" : "categories";
  let t14;
  if ($[31] !== selectedInterests.length || $[32] !== t12 || $[33] !== t13) {
    t14 = <div className={t12}>{selectedInterests.length}{" "}{t13}</div>;
    $[31] = selectedInterests.length;
    $[32] = t12;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t11 || $[36] !== t14) {
    t15 = <div className="flex items-center justify-between pt-3 sm:pt-4 pb-3 sm:pb-4 border-t border-gray-200">{t11}{t14}</div>;
    $[35] = t11;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  const t16 = selectedInterests.length === 0 || isSendingOtp || categoriesLoading || categories.length === 0;
  const t17 = `flex-1 px-4 sm:px-6 py-3 sm:py-3.5 rounded-lg transition-colors font-medium text-sm sm:text-base ${theme.font} ${selectedInterests.length === 0 || isSendingOtp || categoriesLoading || categories.length === 0 ? "bg-gray-200 text-gray-400 cursor-not-allowed" : `${theme.bg} text-white ${theme.hoverBg}`}`;
  const t18 = isSendingOtp ? "Sending code..." : "Next";
  let t19;
  if ($[38] !== onSubmit || $[39] !== t16 || $[40] !== t17 || $[41] !== t18) {
    t19 = <button type="button" onClick={onSubmit} disabled={t16} className={t17}>{t18}</button>;
    $[38] = onSubmit;
    $[39] = t16;
    $[40] = t17;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  const t20 = `px-6 sm:px-8 py-3 sm:py-3.5 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors text-gray-700 font-medium text-sm sm:text-base ${theme.font}`;
  let t21;
  if ($[43] !== onCancel || $[44] !== t20) {
    t21 = <button type="button" onClick={onCancel} className={t20}>Cancel</button>;
    $[43] = onCancel;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== t19 || $[47] !== t21) {
    t22 = <div className="flex gap-2 sm:gap-3">{t19}{t21}</div>;
    $[46] = t19;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== otpSendError || $[50] !== theme.font) {
    t23 = otpSendError && <p className={`mt-2 text-xs sm:text-sm text-red-500 ${theme.font}`}>{otpSendError}</p>;
    $[49] = otpSendError;
    $[50] = theme.font;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== t15 || $[53] !== t22 || $[54] !== t23 || $[55] !== t5 || $[56] !== t7 || $[57] !== t8) {
    t24 = <motion.div key="interests" initial={t1} animate={t2} exit={t3}>{t5}{t7}{t8}{t15}{t22}{t23}</motion.div>;
    $[52] = t15;
    $[53] = t22;
    $[54] = t23;
    $[55] = t5;
    $[56] = t7;
    $[57] = t8;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  return t24;
}